export default __webpack_public_path__ + "static/media/2.2eb46569.jpg";